import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button, Row, Col, Card, CardBody, CardHeader, Table } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import 'react-calendar/dist/Calendar.css';
import axios from "axios";
import { toast } from "react-toastify";
import "../../../src/styles/style.css";
import { getTicketType, getTicketSubType, getTicketSubSubType, getZoneListByPlace, getSubZoneListByZone, getSubSubZoneListBySubZone, getVehicalCategoryList, getVehicalTypeList, getTicketsPerDay } from "../../redux/actions/indexActions";
import { AiOutlineDelete, AiOutlineEdit } from "react-icons/ai";
const TicketNumber = ({ placeId }) => {
    const dispatch = useDispatch();
    const { auth } = useSelector((state) => state.AuthReducer);
    const { indexReducer: { ticketsPerDay,TicketTypeList, TicketSubTypeList, TicketSubSubTypeList, SubZonelists, SubSubZonelists, PlaceZonelists, VehicalCategoryList, VehicalsTypelists } } = useSelector((state) => state);
    const [placeZoneId, setPlaceZoneId] = useState(0);
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        ticket_type: "",
        ticket_type_value: "",

        ticket_sub_type: "",
        ticket_sub_type_value: "",

        ticket_sub_sub_type: "",
        ticket_sub_sub_type_value: "",

        zone_id: "",
        zone_id_value: "",

        sub_zone: "",
        sub_zone_value: "",

        sub_sub_zone: "",
        sub_sub_zone_value: "",

        vehical_category: "",
        vehical_category_value: "",

        vehicle_type: "",
        vehicle_type_value: "",

        show_id: "",
        show_value: "",

        show_timing_id: "",
        show_timing_value: "",
    });

    useEffect(() => {
        dispatch(getTicketType(auth.token, placeId));
        dispatch(getZoneListByPlace(auth.token, placeId));
        dispatch(getTicketsPerDay(auth.token, placeId));
    }, [dispatch, auth.token, placeId]);

    useEffect(() => {
        if (!Array.isArray(ticketsPerDay) || ticketsPerDay.length === 0) return;

        const newFormData = {};
        let zoneIdToSet = null;

        ticketsPerDay.forEach((item) => {
            const type = item.ticket_number_type;

            switch (type) {
                case 'ticket_type':
                    newFormData.ticket_type = item?.ticket_type_id;
                    newFormData.ticket_type_value = item?.number_of_ticket;
                    dispatch(getTicketSubType(auth.token, item?.ticket_type_id));
                    break;

                case 'ticket_sub_type':
                    newFormData.ticket_sub_type = item?.ticket_sub_type_id;
                    newFormData.ticket_sub_type_value = item?.number_of_ticket;
                    dispatch(getTicketSubSubType(auth.token, item?.ticket_sub_type_id));
                    break;

                case 'ticket_sub_sub_type':
                    newFormData.ticket_sub_sub_type = item?.ticket_sub_sub_type_id;
                    newFormData.ticket_sub_sub_type_value = item?.number_of_ticket;
                    break;

                case 'zone':
                    newFormData.zone_id = item?.zone_id;
                    newFormData.zone_id_value = item?.number_of_ticket;
                    zoneIdToSet = item?.zone_id;
                    dispatch(getVehicalCategoryList(auth.token, item?.zone_id));
                    dispatch(getSubZoneListByZone(auth.token, item?.zone_id));
                    break;

                case 'sub_zone':
                    newFormData.sub_zone = item?.sub_zone_id;
                    newFormData.sub_zone_value = item?.number_of_ticket;
                    dispatch(getSubSubZoneListBySubZone(auth.token, item?.sub_zone_id));
                    break;

                case 'sub_sub_zone':
                    newFormData.sub_sub_zone = item?.sub_sub_zone_id;
                    newFormData.sub_sub_zone_value = item?.number_of_ticket;
                    break;

                case 'vehical_category':
                    newFormData.vehical_category = item?.vehical_category_id;
                    newFormData.vehical_category_value = item?.number_of_ticket;
                    dispatch(getVehicalTypeList(auth.token, item?.vehical_category_id));
                    break;

                case 'vehicle_type':
                    newFormData.vehicle_type = item?.vehicle_type_id;
                    newFormData.vehicle_type_value = item?.number_of_ticket;
                    break;

                case 'show':
                    newFormData.show_id = item?.show_id;
                    newFormData.show_value = item?.number_of_ticket;
                    if(!SubZonelists && !VehicalCategoryList){
                        dispatch(getVehicalCategoryList(auth.token, item?.show_id));
                        dispatch(getSubZoneListByZone(auth.token, item?.show_id));
                    }
                    break;

                case 'show_timing':
                    newFormData.show_timing_id = item?.show_timing_id;
                    newFormData.show_timing_value = item?.number_of_ticket;
                    break;

                default:
                    break;
            }
        });

        setFormData((prev) => ({
            ...prev,
            ...newFormData,
        }));

        if (zoneIdToSet) {
            setPlaceZoneId(zoneIdToSet);
        }
    }, [ticketsPerDay]);



    const inputHandler = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (name === "ticket_type") {
            dispatch(getTicketSubType(auth.token, value));
        } else if (name === "ticket_sub_type") {
            dispatch(getTicketSubSubType(auth.token, value));
        } else if (name === "zone_id" || name === "show_id") {
            setPlaceZoneId(value);
            dispatch(getVehicalCategoryList(auth.token, value));
            dispatch(getSubZoneListByZone(auth.token, value));
        } else if (name === "sub_zone") {
            dispatch(getSubSubZoneListBySubZone(auth.token, value));
        } else if (name === "vehical_category") {
            dispatch(getVehicalTypeList(auth.token, value));
        }

    }
    const handleSubmit = () => {
        if (!placeId) {
            toast.error("Place ID is required.");
            return;
        }

        if (!formData || Object.keys(formData).length === 0) {
            toast.error("Form data is required.");
            return;
        }
        // for (const key in formData) {
        //     if (!formData[key]) {
        //         toast.error(`${key} is required.`);
        //         return;
        //     }
        // }
        const form = new FormData();
        for (const key in formData) {
            form.append(key, formData[key]);
        }
        form.append("place_id", placeId);
        axios.post(`/api/admin/v1/addUpdate-number-of-tickets`, form, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${auth?.token}`,
            },
        }).then((res) => {
            toast.success(res.data?.message);
            dispatch(getTicketType(auth.token, placeId));
        }).catch((err) => {
            if (err.response) {
                const errorMessage = err.response.data?.message || "An error occurred";
                toast.error(errorMessage);
                setErrors(err.response.data);
            } else if (err.request) {
                toast.error("No response from server. Please check your connection.");
            } else {
                toast.error("An unexpected error occurred.");
            }
        });
    };

    const [state, setState] = useState({
        placeZone: 0,
        placeSubZone: 0,
        placeSubSubZone: 0,
        groupBookingType: 0,
        subGroupBookingType: 0,
        subSubGroupBookingType: 0,
        is_attech_document: 0,
        additionalFieldType: "",
        additional_field_id: "",
        sub_additional_field_id: "",
        group_booking_type: "",
        sub_group_booking_type: "",
        sub_sub_group_booking_type: "",
    });
    return (
        <div className="container bg-white p-4 rounded shadow-lg">
            <Row>
                <Col md={4}>
                    <FormGroup className="d-flex align-items-center">


                        <Label className="mb-0">Ticket Type</Label>
                    </FormGroup>
                    <>
                        <div className="mb-3">
                            <Input type="select" name="ticket_type" value={formData.ticket_type} onChange={inputHandler}>
                                <option value="">Select Ticket Type</option>
                                {TicketTypeList.map(item => <option key={item.id} value={item.id}>{item.ticket_type}</option>)}
                            </Input>
                        </div>
                        <div className="mb-3">
                            <Input type="number" name="ticket_type_value" value={formData.ticket_type_value} onChange={inputHandler} min="1" placeholder="Number of tickets" />
                        </div>
                    </>
                </Col>
                <Col md={4}>
                    <FormGroup className="d-flex align-items-center">
                        <Label className="mb-0">Ticket Sub Type</Label>
                    </FormGroup>
                    <>
                        <div className="mb-3">
                            <Input type="select" name="ticket_sub_type" value={formData.ticket_sub_type} onChange={inputHandler} disabled={!formData.ticket_type}>
                                <option value="">Select Ticket Sub Type</option>
                                {TicketSubTypeList.map(item => <option key={item.id} value={item.id}>{item.sub_type}</option>)}
                            </Input>
                        </div>
                        <div className="mb-3">
                            <Input type="number" name="ticket_sub_type_value" value={formData.ticket_sub_type_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                        </div>
                    </>
                </Col>
                <Col md={4}>
                    <FormGroup className="d-flex align-items-center">
                        <Label className="mb-0">Ticket Sub Sub Type</Label>
                    </FormGroup>
                    <>
                        <div className="mb-3">
                            <Input type="select" name="ticket_sub_sub_type" value={formData.ticket_sub_sub_type} onChange={inputHandler} disabled={!formData.ticket_sub_type}>
                                <option value="">Select Ticket Sub Sub Type</option>
                                {TicketSubSubTypeList.map(item => <option key={item.id} value={item.id}>{item.sub_sub_type}</option>)}
                            </Input>
                        </div>
                        <div className="mb-3">
                            <Input type="number" name="ticket_sub_sub_type_value" value={formData.ticket_sub_sub_type_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                        </div>
                    </>
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <div className="row">
                        <div className="col-md-12">
                            <Card className="mb-4 shadow-sm">
                                <CardHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0">For Zone </h6>
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <FormGroup>
                                                <Label className="fw-bold">

                                                    Place Zone <span className="text-danger">*</span></Label>
                                                <Input type="select" name="zone_id" value={placeZoneId} onChange={inputHandler}>
                                                    <option value="">Select Ticket Type</option>
                                                    {PlaceZonelists.map(item => <option key={item.id} value={item.id}>{item.zone_name}</option>)}
                                                </Input>
                                                {errors?.place_id && (<span className="d-block text-danger mt-1">{errors.place_id}</span>)}
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="fw-bold">

                                                    Select Sub Zone <span className="text-danger">*</span></Label>
                                                <Input type="select" name="sub_zone" value={formData.sub_zone} onChange={inputHandler}>
                                                    <option value="">Select  Sub Zone</option>
                                                    {SubZonelists.map(item => <option key={item.id} value={item.id}>{item.sub_zone}</option>)}
                                                </Input>
                                                <span className="text-danger">{errors?.tourist_type}</span>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="fw-bold">
                                                    Select Sub Sub Zone
                                                    <span className="text-danger">*</span></Label>
                                                <Input type="select" name="sub_sub_zone" value={formData.sub_sub_zone} onChange={inputHandler}>
                                                    <option value="">Select Sub Sub Zone</option>
                                                    {SubSubZonelists.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.sub_sub_zone}</option>
                                                    ))}
                                                </Input>
                                                <span className="text-danger">{errors?.tourist_type}</span>
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="zone_id_value" value={formData.zone_id_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="sub_zone_value" value={formData.sub_zone_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="sub_sub_zone_value" value={formData.sub_sub_zone_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <textarea
                                                className="form-control"
                                                placeholder="Description" rows="1"
                                                name="description"
                                            >
                                            </textarea>
                                        </div>
                                    </div> */}
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </Col>
                <Col md={6}>
                    <div className="row">
                        <div className="col-md-12">
                            <Card className="mb-4 shadow-sm">
                                <CardHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0">For Safari Vehicle</h6>
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <FormGroup>
                                                <Label className="fw-bold">
                                                    Vehical Category <span className="text-danger">*</span></Label>
                                                <Input type="select" name="vehical_category" value={formData.vehical_category} onChange={inputHandler}>
                                                    <option value="">Select Vehical Category</option>
                                                    {VehicalCategoryList.map(item => <option key={item.id} value={item.id}>{item.vehicle_category}</option>)}
                                                </Input>
                                                {errors?.place_id && (<span className="d-block text-danger mt-1">{errors.place_id}</span>)}
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="fw-bold">
                                                    Vehical Type/Name <span className="text-danger">*</span></Label>
                                                <Input type="select" name="vehicle_type" value={formData.vehicle_type} onChange={inputHandler}>
                                                    <option value="" className="">Select</option>
                                                    {VehicalsTypelists.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.vehicle_type}</option>
                                                    ))}
                                                </Input>
                                                <span className="text-danger">{errors?.tourist_type}</span>
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="vehical_category_value" value={formData.vehical_category_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="vehicle_type_value" value={formData.vehicle_type_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card className="mb-4 shadow-sm">
                                <CardHeader className="bg-secondary text-white d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0">For Show</h6>
                                </CardHeader>
                                <CardBody>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <FormGroup>
                                                <Label className="fw-bold">
                                                    Show <span className="text-danger">*</span></Label>
                                                <Input type="select" name="show_id" value={formData?.show_id} onChange={inputHandler}>
                                                    <option value="">Select Show</option>
                                                    {PlaceZonelists.map((item) => (
                                                        <option key={item.id} value={item.id}>{item.zone_name}</option>
                                                    ))}
                                                </Input>
                                                {errors?.place_id && (<span className="d-block text-danger mt-1">{errors.place_id}</span>)}
                                            </FormGroup>
                                            <FormGroup>
                                                <Label className="fw-bold">
                                                    Show Timings <span className="text-danger">*</span></Label>
                                                <Input type="select" name="show_timing_id" value={formData?.show_timing_id} onChange={inputHandler}>
                                                    <option value="">Select Show Timings</option>
                                                    {SubZonelists.map((item) => (
                                                        <option key={item.id} value={item.id}>
                                                            {item.sub_zone}
                                                        </option>
                                                    ))}
                                                </Input>
                                                <span className="text-danger">{errors?.tourist_type}</span>
                                            </FormGroup>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="row">
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="show_value" value={formData.show_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12" >
                                                    <FormGroup>
                                                        <Label className="fw-bold"> Tickets</Label>
                                                        <Input type="number" name="show_timing_value" value={formData.show_timing_value} onChange={inputHandler} min="0" placeholder="Number of tickets"/>
                                                    </FormGroup>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>
                    </div>
                </Col>
            </Row>
            <Button color="success"
                onClick={handleSubmit}
                className="mt-3 w-100">
                Submit
            </Button>
        </div>
    );
};

export default TicketNumber;
